import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=ac7964c0&scoped=true"
import script from "./addressBook.vue?vue&type=script&lang=js"
export * from "./addressBook.vue?vue&type=script&lang=js"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=ac7964c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7964c0",
  null
  
)

export default component.exports